import React from 'react';

const Filter = (props) => {
    const {
        label           = null,
        value           = "",
        options         = [],
        name            = "filter_input",
        onChange        = () => {},
        classes         = "",
        inputClasses    = "m-0 p-1 px-2 w-100"
    } = props;

    return (
        <div className={`filter-input ${classes}`}>
            <div className="row">
                {!!label && (
                    <label
                        htmlFor={name}
                        className={"m-0 col-4 xl-col-6"}
                    >
                        {label}
                    </label>
                )}
                <div className="col-8 xl-col-6">
                    <select
                        name={name}
                        id={name}
                        className={inputClasses}
                        onChange={(event) => onChange(event.target.value)}
                        value={value}
                    >
                        {!!options && options.map((item, key) => (
                            <option key={key} value={item.value}>{item.name}</option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
}

export default Filter;
